"use client";

import { Fragment } from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { isSafeFormFunnelContentHref } from "@portal/app/_common/lib/formFunnelContent";
import { usePuckSurfaceTone } from "../surfaceTone";
import type { PageChromeBlockProps } from "../pageChromeTypes";

export function PageLinks({
  label,
  appearance,
  align,
  links,
  inert = true,
}: PageChromeBlockProps["Links"] & { inert?: boolean }) {
  const onBrand = usePuckSurfaceTone("transparent") === "brand";
  const safeLinks = links.filter(
    (link) => link.label.trim() && isSafeFormFunnelContentHref(link.url)
  );
  if (!safeLinks.length) return null;
  const legal = appearance === "legal";
  return (
    <Box
      data-supporting-block
      component="nav"
      aria-label={label.trim() || (legal ? "Legal links" : "Page links")}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: align === "center" ? "center" : "flex-start",
        columnGap: legal ? "12px" : "24px",
        rowGap: "10px",
        width: "100%",
      }}
    >
      {safeLinks.map((link, index) => (
        <Fragment key={`${link.url}-${index}`}>
          {legal && index > 0 && (
            <Box
              component="span"
              aria-hidden
              sx={{ color: onBrand ? "common.white" : "text.secondary", fontSize: 12 }}
            >
              ·
            </Box>
          )}
          <Link
            component={inert ? "span" : "a"}
            href={inert ? undefined : link.url.trim()}
            target={!inert && link.newTab ? "_blank" : undefined}
            rel={!inert && link.newTab ? "noopener noreferrer" : undefined}
            aria-disabled={inert || undefined}
            underline="hover"
            color={onBrand ? "common.white" : legal ? "text.secondary" : "text.primary"}
            sx={{ fontSize: legal ? "0.75rem" : "0.875rem", fontWeight: legal ? 400 : 600 }}
          >
            {link.label}
          </Link>
        </Fragment>
      ))}
    </Box>
  );
}
